import { useQuery, useMutation } from 'react-query'
import API from '.'

const ENDPOINT = '/api/claims'
const QUERY_KEY = 'claims'

export const useGetWarrantyClaim = (id, config = {}) =>
  useQuery([QUERY_KEY, 'detail', id], async () => (await API.get(`${ENDPOINT}/${id}`)).data, config)

export const useGetWarrantyClaims = (params) =>
  useQuery(
    [QUERY_KEY, 'list', params],
    async () => (await API.get(`${ENDPOINT}?${new URLSearchParams(params).toString()}`)).data
  )

export const useCreateWarrantyClaim = (config = {}) =>
  useMutation((data) => API.post(ENDPOINT, data), config)

export const useUpdateWarrantyClaimStatus = (config = {}) =>
  useMutation((data) => API.patch(`${ENDPOINT}/status`, data), config)
